<script lang="ts">
	import type { IEventSlot } from '@api/EventSlotsApi';
	import Tile from './Tile.svelte';
	import { format, getMonth, parseISO } from 'date-fns';
	import { de } from 'date-fns/locale';
	import RightCondensed from '@icons/RightCondensed.svelte';
	import Icon from './Icon.svelte';
	import Price from '@icons/Price.svelte';
	import NavigationLoction from '@icons/NavigationLoction.svelte';
	import { isEvent, isWorkshop } from '$lib/event';
	import Link from './Link.svelte';
	import Person from '@icons/Person.svelte';

	function getFormattedDate(date: string) {
		const threeLetterMonthAbbreviations = [
			'Jan',
			'Feb',
			'Mrz',
			'Apr',
			'Mai',
			'Jun',
			'Jul',
			'Aug',
			'Sep',
			'Okt',
			'Nov',
			'Dez'
		];
		const parsedDate = parseISO(date);
		const monthIndex = getMonth(parsedDate);
		const formattedDay = format(parsedDate, 'd.', { locale: de });
		const formattedYear = format(parsedDate, 'yyyy', { locale: de });

		return `${formattedDay} ${threeLetterMonthAbbreviations[monthIndex]}. ${formattedYear}`;
	}

	export let event: IEventSlot;
	export let isWideTile = false;
	export let shouldReload = true;
	export let loading: 'eager' | 'lazy' = 'eager';
</script>

<Tile
	class="bg-white w-full min-w-74 relative text-copy flex-grow-0 overflow-hidden {isWideTile
		? 'xl:col-span-2 xl:max-w-none '
		: ''}"
>
	<img
		class="min-h-60 object-cover object-center w-full normal-tile-aspect-ratio {isWideTile
			? 'wide-tile-aspect-ratio'
			: ''}"
		src={event.event.image_for_tile.original}
		alt={event.event.image_for_tile_alt || ''}
		{loading}
	/>

	<div class="p-4.5">
		<div class="mb-3">
			<span class="text-magenta text-copy font-extrabold">
				<!-- TODO: remove after event -->
				<!-- special display withouth starts at for prod event 'Mini Tischkicker Turnier' -->
				{#if event.event.id == '163'}
					&nbsp;
				{:else}
					{getFormattedDate(event.starts_at)}
				{/if}
			</span>

			{#if event.slot_count > 1}
				<Link
					tag="a"
					href={`/${event.event.slug}#termine`}
					{shouldReload}
					trackingLabel={`+ ${event.slot_count - 1} weitere Termine`}
					>+ {event.slot_count - 1} weitere Termine</Link
				>
			{/if}
		</div>

		<div
			class="text-quaternary font-bold mb-3 text-wrap min-h-[4.6875rem] {isWideTile
				? 'xl:min-h-[3.125rem]'
				: ''}"
		>
			{event.event.name}
		</div>

		<div class="flex flex-col" class:xl:flex-row={isWideTile}>
			<div
				class="flex gap-3 flex-col mb-3"
				class:xl:flex-row={isWideTile}
				class:xl:mb-0={isWideTile}
			>
				<div class="flex gap-1.5" class:xl:hidden={isWideTile && event?.event?.fsk < 1}>
					{#if event?.event?.fsk > 0}
						<Icon component={Person} class="!w-5 !h-5" />
						{`Mindestalter: ${event.event.fsk} Jahre`}
					{:else}
						<div class="w-5 h-6" aria-hidden="true" />
					{/if}
				</div>
				<div class="flex gap-1.5 items-center">
					<Icon component={NavigationLoction} class="!w-5 !h-5" aria-label="Ort" />

					{event.location_count > 1
						? `${event.location_count} Standorte`
						: event.location.address.city}
				</div>
				<div class="flex gap-1.5">
					<Icon component={Price} class="!w-5 !h-5" aria-label="Kosten" />
					{event.event.participation_fee_in_cents > 0
						? ` | ${event.event.participation_fee_in_cents / 100} €`
						: 'Kostenlos'}
				</div>
			</div>

			<Link
				tag="a"
				href="/{event.event.slug}"
				rightIcon={RightCondensed}
				class="ml-auto"
				trackingLabel={isWorkshop(event.event.event_type) ? 'Mehr zum Workshop' : 'Mehr zum Event'}
				{shouldReload}
			>
				{#if isWorkshop(event.event.event_type)}
					Mehr zum Workshop
				{/if}
				{#if isEvent(event.event.event_type)}
					Mehr zum Event
				{/if}
			</Link>
		</div>
	</div></Tile
>

<style>
	.normal-tile-aspect-ratio {
		aspect-ratio: 4 / 3;
	}

	.wide-tile-aspect-ratio {
		/* aspect-ratio: 629 / 362; */
		@media screen and (min-width: 1344px) {
			aspect-ratio: 5 / 3;
		}
	}
</style>
